module.exports = __webpack_public_path__ + "static/homelessness-6784cb2f724600358e32603f610dfcd5.jpg";